const menu = document.getElementById('mainMenu'),
      burger = document.getElementById('hamburger'),
      htmlEl = document.getElementsByTagName('HTML')[0],
      background = document.querySelector('.main-menu__background')

export default function() {
  burger.addEventListener('click', () => {
    menu.classList.toggle('active')
    burger.classList.toggle('is-active')
    htmlEl.classList.toggle('nav-active')
  })

  background.addEventListener('click', () => {
    menu.classList.remove('active')
    burger.classList.remove('is-active')
    htmlEl.classList.remove('nav-active')
  })
}